import { ACTION_TYPES, HOME_ROUTES } from './actions'

export const LAUNCH_STEP_IDS = {
  BRANDING: 'branding',
  PORTAL: 'portal',
  FIRST_COURSE: 'first_course',
  CONNECT_AI: 'connect_ai',
}

/**
 * Ordered "Create and launch your academy" steps.
 * Completion is resolved in `useLaunchProgress` by step id.
 */
export const LAUNCH_STEPS = [
  {
    id: LAUNCH_STEP_IDS.BRANDING,
    title: 'Add your branding',
    description: 'Logo and one primary colour.',
    duration: '1 min',
    ctaLabel: 'Open branding',
    action: { type: ACTION_TYPES.ROUTE, to: HOME_ROUTES.BRANDING },
  },
  {
    id: LAUNCH_STEP_IDS.PORTAL,
    title: 'Set up your portal',
    description: 'Name, cover and access rules.',
    duration: '2 min',
    ctaLabel: 'Portal settings',
    action: { type: ACTION_TYPES.OPEN_PORTAL },
  },
  {
    id: LAUNCH_STEP_IDS.FIRST_COURSE,
    title: 'Create your first course',
    description: 'Upload a PDF or start blank.',
    duration: '4 min',
    ctaLabel: 'Create course',
    action: { type: ACTION_TYPES.CREATE_COURSE },
  },
  {
    id: LAUNCH_STEP_IDS.CONNECT_AI,
    title: 'Connect Claude & ChatGPT',
    description: 'Build courses from your AI tool.',
    duration: '2 min',
    ctaLabel: 'Connect',
    action: { type: ACTION_TYPES.ROUTE, to: HOME_ROUTES.CONNECT_AI },
  },
]
